import styled from 'styled-components';

import Select from 'components/Select';

export const StyledSelect = styled(Select)`
  width: 173px;
`;
